<template>
  <CreateOrderLayout @next="next">
    <div class="kt-portlet">
      <div v-for="(component, index) in components" :key="index">
        <div class="kt-portlet__head">
          <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
              {{ component.title }}
              {{ component.is_optional ? "(optional)" : "" }}
              <small>{{ component.description }}</small>
            </h3>
          </div>
          <div class="kt-portlet__head-toolbar" v-if="component.is_optional">
            <button
              type="button"
              class="btn btn-secondary"
              :class="[
                serviceComponents[component.slug] !== null ? 'btn-brand' : '',
              ]"
              @click="removeComponent(component.id, component.slug)"
            >
              Skip
            </button>
          </div>
        </div>

        <div class="kt-portlet__body">
          <div class="row no-gutters justify-content-md-center">
            <div
              :class="selectableOptionSize"
              v-for="choice in component.choices"
              :key="choice.id"
            >
              <label
                class="kt-option pt-3"
                :class="[
                  isIdContains(component.slug, choice.id) ? 'border-blue' : '',
                ]"
              >
                <span class="kt-option__control mt-4 mb-2">
                  <span
                    class="kt-checkbox kt-checkbox--brand"
                    v-if="component.allow_multiple"
                  >
                    <input
                      type="checkbox"
                      v-model="serviceComponents[component.slug]"
                      :value="choice.id"
                      @change="setComponent(component.id, component.slug)"
                    />
                    <span></span>
                  </span>
                  <span class="kt-radio kt-radio--bold kt-radio--brand" v-else>
                    <input
                      type="radio"
                      :name="'radio-' + component.id"
                      v-model="serviceComponents[component.slug]"
                      :value="choice.id"
                      @change="
                        setComponent(component.id, component.slug, choice.id)
                      "
                    />
                    <span></span>
                  </span>
                </span>
                <span class="kt-option__label">
                  <span class="kt-option__head">
                    <img class="mx-auto border-0" :src="choice.cover" />
                  </span>
                  <span class="kt-option__body text-center">
                    <h4>{{ choice.title }}</h4>
                    <p class="text-muted lead">${{ choice.price }} per image</p>
                  </span>
                  <p></p>
                </span>
              </label>
            </div>
          </div>
        </div>
        <div v-if="index <= components.length - 1" class="border"></div>
      </div>

      <div class="kt-portlet__head" v-if="addonsEnabled">
        <div class="kt-portlet__head-label">
          <h3 class="kt-portlet__head-title">
            We offer additional services for your images.
            <strong>(Optional)</strong>
            <small>You can select multiple or leave it blank.</small>
          </h3>
        </div>
      </div>
      <div class="border" v-if="addonsEnabled"></div>
      <div class="kt-portlet__body" v-if="addonsEnabled">
        <div class="row no-gutters justify-content-md-center">
          <div :class="selectableOptionSize" v-if="addons.websizes.is_enabled">
            <label
              class="kt-option"
              @click="openModal('resize')"
              :class="[additionalService.websizes ? 'border-blue' : '']"
            >
              <span class="kt-option__control mt-4 mb-2" style="width: 1.8rem">
                <span class="kt-checkbox kt-checkbox--brand">
                  <input type="checkbox" v-model="additionalService.websizes" />
                  <span></span>
                </span>
              </span>
              <span class="kt-option__label  text-center">
                <span class="kt-option__head">
                  <img
                    :src="addons.websizes.cover_image"
                    class="rounded-top pt-3 pb-4 mx-auto"
                    alt
                  />
                </span>
                <span class="kt-option__body">
                  <h3>Websize</h3>
                  <p class="text-muted lead">
                    +${{ addons.websizes.price }} per image
                  </p>
                </span>
                <span class="kt-option__body text-center">
                  <button type="button" class="btn btn-secondary btn-icon mr-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                      class="kt-svg-icon"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <polygon points="0 0 24 0 24 24 0 24" />
                        <path
                          d="M6,5 L18,5 C19.6568542,5 21,6.34314575 21,8 L21,17 C21,18.6568542 19.6568542,20 18,20 L6,20 C4.34314575,20 3,18.6568542 3,17 L3,8 C3,6.34314575 4.34314575,5 6,5 Z M5,17 L14,17 L9.5,11 L5,17 Z M16,14 C17.6568542,14 19,12.6568542 19,11 C19,9.34314575 17.6568542,8 16,8 C14.3431458,8 13,9.34314575 13,11 C13,12.6568542 14.3431458,14 16,14 Z"
                          fill="#000000"
                        />
                      </g>
                    </svg>
                  </button>
                </span>
              </span>
            </label>
          </div>
          <div :class="selectableOptionSize" v-if="addons.margin.is_enabled">
            <label
              class="kt-option"
              @click="openModal('margin')"
              :class="[additionalService.margin ? 'border-blue' : '']"
            >
              <span class="kt-option__control mt-4 mb-2" style="width: 1.8rem">
                <span class="kt-checkbox kt-checkbox--brand">
                  <input
                    type="checkbox"
                    value="margin"
                    v-model="additionalService.margin"
                  />
                  <span></span>
                </span>
              </span>

              <span class="kt-option__label">
                <span class="kt-option__head">
                  <img
                    :src="addons.margin.cover_image"
                    class="rounded-top pt-3 pb-4 mx-auto"
                    alt
                  />
                </span>
                <span class="kt-option__body text-center">
                  <h3>Margin</h3>
                  <!-- <p class="text-muted lead">+${{ addons.margin.price }} per image</p>-->
                  <p class="text-muted lead">Configure options</p>
                </span>
                <span class="kt-option__body text-center">
                  <button type="button" class="btn btn-secondary btn-icon mr-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                      class="kt-svg-icon"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <polygon points="0 0 24 0 24 24 0 24" />
                        <path
                          d="M6,5 L18,5 C19.6568542,5 21,6.34314575 21,8 L21,17 C21,18.6568542 19.6568542,20 18,20 L6,20 C4.34314575,20 3,18.6568542 3,17 L3,8 C3,6.34314575 4.34314575,5 6,5 Z M5,17 L14,17 L9.5,11 L5,17 Z M16,14 C17.6568542,14 19,12.6568542 19,11 C19,9.34314575 17.6568542,8 16,8 C14.3431458,8 13,9.34314575 13,11 C13,12.6568542 14.3431458,14 16,14 Z"
                          fill="#000000"
                        />
                      </g>
                    </svg>
                  </button>
                </span>
              </span>
            </label>
          </div>
          <div
            :class="selectableOptionSize"
            v-if="addons.adjustment.is_enabled"
          >
            <label
              class="kt-option"
              @click="openModal('adjustment')"
              :class="[additionalService.adjustment ? 'border-blue' : '']"
            >
              <span class="kt-option__control mt-4 mb-2" style="width: 1.8rem">
                <span class="kt-checkbox kt-checkbox--brand">
                  <input
                    type="checkbox"
                    v-model="additionalService.adjustment"
                  />
                  <span></span>
                </span>
              </span>
              <span class="kt-option__label">
                <span class="kt-option__head">
                  <img
                    :src="addons.adjustment.cover_image"
                    class="rounded-top pt-3 pb-4 mx-auto"
                    alt
                  />
                </span>
                <span class="kt-option__body text-center">
                  <h3>Adjustment</h3>
                  <p class="text-muted lead">
                    +${{ addons.adjustment.price }} per image
                  </p>
                </span>
                <span class="kt-option__body text-center">
                  <button type="button" class="btn btn-secondary btn-icon mr-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                      class="kt-svg-icon"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <polygon points="0 0 24 0 24 24 0 24" />
                        <path
                          d="M6,5 L18,5 C19.6568542,5 21,6.34314575 21,8 L21,17 C21,18.6568542 19.6568542,20 18,20 L6,20 C4.34314575,20 3,18.6568542 3,17 L3,8 C3,6.34314575 4.34314575,5 6,5 Z M5,17 L14,17 L9.5,11 L5,17 Z M16,14 C17.6568542,14 19,12.6568542 19,11 C19,9.34314575 17.6568542,8 16,8 C14.3431458,8 13,9.34314575 13,11 C13,12.6568542 14.3431458,14 16,14 Z"
                          fill="#000000"
                        />
                      </g>
                    </svg>
                  </button>
                </span>
              </span>
            </label>
          </div>
          <div :class="selectableOptionSize" v-if="addons.retouch.is_enabled">
            <label
              class="kt-option"
              @click="openModal('retouch')"
              :class="[additionalService.retouch ? 'border-blue' : '']"
            >
              <span class="kt-option__control mt-4 mb-2" style="width: 1.8rem">
                <span class="kt-checkbox kt-checkbox--brand">
                  <input type="checkbox" v-model="additionalService.retouch" />
                  <span></span>
                </span>
              </span>
              <span class="kt-option__label">
                <span class="kt-option__head">
                  <img
                    :src="addons.retouch.cover_image"
                    class="rounded-top pt-3 pb-4 mx-auto"
                    alt
                  />
                </span>
                <span class="kt-option__body text-center">
                  <h3>Retouch</h3>
                  <!-- <p class="text-muted lead">From ${{ addons.retouch.price }} per image</p>-->
                  <p class="text-muted lead">Select Retouch Type</p>
                </span>
                <span class="kt-option__body text-center">
                  <button type="button" class="btn btn-secondary btn-icon mr-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                      class="kt-svg-icon"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <polygon points="0 0 24 0 24 24 0 24" />
                        <path
                          d="M6,5 L18,5 C19.6568542,5 21,6.34314575 21,8 L21,17 C21,18.6568542 19.6568542,20 18,20 L6,20 C4.34314575,20 3,18.6568542 3,17 L3,8 C3,6.34314575 4.34314575,5 6,5 Z M5,17 L14,17 L9.5,11 L5,17 Z M16,14 C17.6568542,14 19,12.6568542 19,11 C19,9.34314575 17.6568542,8 16,8 C14.3431458,8 13,9.34314575 13,11 C13,12.6568542 14.3431458,14 16,14 Z"
                          fill="#000000"
                        />
                      </g>
                    </svg>
                  </button>
                </span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <ResizeModal @websizes="saveWebsizes" @close="closeWebsizes"></ResizeModal>
    <AdjustmentModal
      @adjustment="saveAdjustment"
      @close="closeAdjustment"
    ></AdjustmentModal>
    <MarginModal @margin="saveMargin" @close="closeMargin"></MarginModal>
    <RetouchModal @retouch="saveRetouch" @close="closeRetouch"></RetouchModal>
  </CreateOrderLayout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CreateOrderLayout from "@/layouts/CreateOrderLayout.vue";
import EventBus from "@/eventBus";
import ResizeModal from "@/components/ResizeModal.vue";
import AdjustmentModal from "@/components/AdjustmentModal.vue";
import MarginModal from "@/components/MarginModal.vue";
import RetouchModal from "@/components/RetouchModal.vue";
import BeforeLeaveOrderFormMixin from "@/mixins/beforeLeaveOrderForm.js";

export default {
  name: "StepThree",
  components: {
    CreateOrderLayout,
    ResizeModal,
    AdjustmentModal,
    MarginModal,
    RetouchModal,
  },
  mixins: [BeforeLeaveOrderFormMixin],
  data() {
    return {
      selectableOptionSize: "col-xl-3 col-6 col-sm-4 col-md-3 px-md-2",
      serviceComponents: {},
      additionalService: {
        websizes: false,
        margin: false,
        adjustment: false,
        retouch: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      site: "site/site",
      components: "service/components",
      service: "service/service",
      addons: "service/addons",
      addonsEnabled: "service/addonsEnabled",
      orderWebsizes: "order/websizes",
      orderAddOns: "order/addOns",
      orderServiceComponents: "order/serviceComponents",
    }),
  },

  mounted() {
    this.components.map((component) => {
      if (component.allow_multiple) {
        this.serviceComponents[component.slug] = [];
      } else {
        this.serviceComponents[component.slug] = null;
      }
    });

    this.orderServiceComponents.map((component) => {
      if (Array.isArray(this.serviceComponents[component.slug])) {
        this.serviceComponents[component.slug] = component.choices;
      } else {
        this.serviceComponents[component.slug] = component.choices[0];
      }
    });

    if (this.orderWebsizes.length !== 0) {
      this.additionalService.websizes = true;
    }

    Object.keys(this.orderAddOns).forEach((key) => {
      this.additionalService[key] = true;
    });

    this.$forceUpdate();
  },

  methods: {
    ...mapActions({
      setAddOns: "order/setAddOns",
      deleteAddOns: "order/deleteAddOns",
      setServiceComponent: "order/setServiceComponent",
      removeServiceComponent: "order/removeServiceComponent",
    }),
    isIdContains(slug, id) {
      if (Array.isArray(this.serviceComponents[slug])) {
        return this.serviceComponents[slug].includes(id);
      } else {
        return this.serviceComponents[slug] == id;
      }
    },
    setComponent(id, slug) {
      let choices = Array.isArray(this.serviceComponents[slug])
        ? this.serviceComponents[slug]
        : [this.serviceComponents[slug]];
      this.setServiceComponent({
        id: id,
        slug: slug,
        choices: choices,
      });
      EventBus.$emit("data-updated");
      this.$forceUpdate();
    },
    removeComponent(id, slug, choiceId) {
      this.removeServiceComponent({
        id: id,
      });

      if (Array.isArray(this.serviceComponents[slug])) {
        let index = this.serviceComponents[slug].indexOf(choiceId);

        this.serviceComponents[slug].splice(index, 1);
      } else {
        this.serviceComponents[slug] = null;
        this.$forceUpdate();
      }
      EventBus.$emit("data-updated");
      this.$forceUpdate();
    },
    openModal(name) {
      this.$modal.show(`${name}-modal`);
    },
    saveWebsizes(websizes) {
      this.setAddOns({
        key: "websizes",
        value: websizes,
      });

      if (websizes.length === 0) {
        this.additionalService.websizes = false;
        return;
      }

      this.additionalService.websizes = true;
    },
    closeWebsizes() {
      if (this.orderWebsizes.length !== 0) {
        this.additionalService.websizes = true;
      } else {
        this.additionalService.websizes = false;
      }
    },
    saveMargin(margin) {
      if (margin.marginTypeId === null) {
        this.additionalService.margin = false;

        this.deleteAddOns({
          key: "margin",
        });

        return;
      }

      this.setAddOns({
        key: "margin",
        value: margin,
      });

      this.additionalService.margin = true;
    },
    closeMargin() {
      if (this.orderAddOns.margin) {
        this.additionalService.margin = true;
      } else {
        this.additionalService.margin = false;
      }
    },
    saveAdjustment(adjustment) {
      if (adjustment === "") {
        this.additionalService.adjustment = false;

        this.deleteAddOns({
          key: "adjustment",
        });

        return;
      }

      this.setAddOns({
        key: "adjustment",
        value: adjustment,
      });

      this.additionalService.adjustment = true;
    },
    closeAdjustment() {
      if (this.orderAddOns.adjustment) {
        this.additionalService.adjustment = true;
      } else {
        this.additionalService.adjustment = false;
      }
    },
    saveRetouch(retouch) {
      if (retouch === null) {
        this.additionalService.retouch = false;

        this.deleteAddOns({
          key: "retouch",
        });

        return;
      }

      this.setAddOns({
        key: "retouch",
        value: retouch,
      });

      this.additionalService.retouch = true;
    },
    closeRetouch() {
      if (this.orderAddOns.retouch) {
        this.additionalService.retouch = true;
      } else {
        this.additionalService.retouch = false;
      }
    },
    next() {
      let next = false;
      this.components.map((component) => {
        if (!component.is_optional) {
          if (
            this.serviceComponents[component.slug] === null ||
            this.serviceComponents[component.slug].length === 0
          ) {
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: "Please fill up order required option!",
            });

            next = true;
          }
        }
      });

      if (!next) {
        this.$router.push({
          name: "step-four",
          params: { slug: this.service.slug },
          query: { ...this.$route.query },
        });
      }
    },
  },
};
</script>

<style scoped>
.kt-checkbox,
.kt-radio {
  display: none !important;
}

.upload img {
  padding: 6px 4px;
  max-width: 100%;
  object-fit: cover;
  border: 1px solid #cccccc;
}
.kt-option__head img {
  max-width: 100%;
}
.kt-option {
  padding: 0;
  padding-bottom: 1.4em;
  flex-direction: column-reverse;
  align-items: center;
}
.kt-option:hover {
  border-color: #5d78ff;
}
.border-blue {
  border-color: #5d78ff;
}
</style>
